export const V1_REQUEST_TOUR_OPERATORS = 'V1_REQUEST_TOUR_OPERATORS'

export default () => {
  return {
    type: V1_REQUEST_TOUR_OPERATORS,
  }
}
